module.exports = __webpack_public_path__ + "assets/Retina-BookItalic.7c3ae952e562e7e9b44de8fe03d0ddb3.woff2";